import { Component } from '@angular/core';
import { gildenService } from '../services/gildenService';
import { SettingsService, Settings } from '../services/settingsService';

import ODataContext from "devextreme/data/odata/context";
import DataSource from "devextreme/data/data_source";

@Component({
  selector: 'lisamicha',
  templateUrl: './lisamicha.html'
})
export class MidiInternalComponent {
  
  private context: ODataContext = new ODataContext({
    url: "https://schattenkollektiv.gear.host/",
  entities: {
    polterabend: {
      key: "ID",
      keyType: "int"
    }
    },
    version: 4
});
  private dataSource: DataSource;
  
  constructor() {

    this.dataSource = new DataSource({
      store: this.context['polterabend'],
      pageSize: 10000,
    });
  }

  calculateZusagen(options)
  {
    if (options.name === "ZusagenSummary")
    {
      if (options.summaryProcess === "start") {
        options.totalValue = 0;
      } else if (options.summaryProcess === "calculate") {
        if (options.value.zusage == true) {
          options.totalValue = options.totalValue + options.value.personenanzahl;
        }
      }
    }

  }

}
